import { jsx } from "react/jsx-runtime";
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined";
import { validateTidalLicense } from "../../base/index.js";
function EmojiEventsOutlined(props) {
  return /* @__PURE__ */ jsx(
    EmojiEventsOutlinedIcon,
    {
      "data-testid": "EmojiEventsOutlined",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "EmojiEventsOutlined",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
EmojiEventsOutlined.tidalIconMeta = {
  categories: "miscellaneous",
  name: "EmojiEventsOutlined"
};
validateTidalLicense();
export {
  EmojiEventsOutlined
};
//# sourceMappingURL=EmojiEventsOutlined.js.map
